import { $t } from "@/plugins/i18n"

import { Epic } from "../Epic"
import { Notification } from "./Notification"

export class NotificationEpic extends Notification {
  constructor(props) {
    super(props)
  }

  get epic(): Epic {
    return this.content?.epic ? new Epic(this.content.epic) : new Epic()
  }

  get oldEpic(): Epic {
    return this.content?.oldEpic ? new Epic(this.content.oldEpic) : new Epic()
  }

  get epicSequenceNumber() {
    return `E-${this.epic?.sequenceNumber ?? $t("none")}`
  }

  get epicName() {
    return this.epic?.name ?? $t("none")
  }

  get epicUrl() {
    return this.content?.epic?.url
  }

  get epicDescription() {
    return this.epic?.structuredDescription?.html ?? ""
  }

  get descriptionChanged() {
    return Boolean(this.content?.descriptionChanged)
  }

  get nameChanged() {
    return Boolean(this.content?.nameChanged)
  }

  get initiatorFullName() {
    const initiator = this.content?.initiator ?? this.content?.initiators?.[0]
    if (!initiator) return ""
    return initiator.firstName + " " + initiator.lastName
  }

  get attachments() {
    return this.content?.attachmentsMetadata?.attachments || []
  }

  get attachmentsCount() {
    return this.content?.attachmentsMetadata?.attachmentsCount ?? 0
  }
}
